import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isObject, isString } from 'lodash';
import { FormattedMessage } from 'react-intl';

import theme from './FormStyles.scss';

const propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

const FormError = ({ error, className }) => error && (
  <div className={ classnames(className, theme.formError, theme.fadeIn) }>
    <Choose>
      <When condition={ isObject(error) }>
        <FormattedMessage { ...error } />
      </When>
      <When condition={ isString(error) }>
        { error }
      </When>
    </Choose>
  </div>
);

FormError.propTypes = propTypes;
FormError.defaultProps = defaultProps;

export default FormError;
